export const COLLECT_MENU_POSITIONS = {
    BOTTOM_RIGHT: 'bottom-end',
    BOTTOM_LEFT: 'bottom-start',
};
